import type { TextFieldProps } from '@capsule/consumer-design-system';
import { TextField } from '@capsule/consumer-design-system';

import { getIn, useFormikContext } from 'formik';

/**
 * Lots of issues with this type of input masking around mid-value changes.
 * TODO: Revisit input masking entirely and re-think a more accessible solution.
 */
const useInputMask = (pattern: string) => {
  const maskSeparators = pattern.replace(/[^\s-]/g, '').split('');

  const maskSeparatorsSet = new Set(maskSeparators);

  const applyMask = (rawInput: string) => {
    const unmaskedInput = rawInput
      // .replace(/\D/g, '') // remove non-digits
      .replace(new RegExp(`[${Array.from(maskSeparatorsSet).join('')} ]*`, 'g'), ''); // apply mask

    let result = '';
    let unmaskedIndex = 0;

    for (let maskIndex = 0; maskIndex < pattern.length && unmaskedIndex < unmaskedInput.length; maskIndex++) {
      if (maskSeparatorsSet.has(pattern[maskIndex])) {
        result += pattern[maskIndex];
      } else {
        if (unmaskedInput[unmaskedIndex]) {
          result += unmaskedInput[unmaskedIndex++];
        }
      }
    }

    return result;
  };

  return { applyMask };
};

interface FormikTextFieldProps extends Omit<TextFieldProps, 'inputMode' | 'pattern' | 'type'> {}

export const FormikPhoneField = ({ name, onBlur, onChange, ...props }: FormikTextFieldProps) => {
  const { errors, touched, values, handleBlur, handleChange } = useFormikContext();
  const error = getIn(touched, name) && getIn(errors, name);
  const value = getIn(values, name);

  const { applyMask } = useInputMask('999-999-9999');

  return (
    <TextField
      name={name}
      value={value}
      error={error}
      onBlur={event => {
        onBlur?.(event);
        handleBlur(event);
      }}
      onChange={event => {
        event.target.value = applyMask(event.target.value);
        onChange?.(event);
        handleChange(event);
      }}
      onKeyDown={e => {
        const isDigit = /^\d$/.test(e.key);
        const isOtherValidKey = ['Backspace', 'Delete', 'Tab', 'ArrowLeft', 'ArrowRight', 'Enter'].includes(e.key);

        if (!isDigit && !isOtherValidKey) {
          e.preventDefault();
        }
      }}
      type="tel"
      pattern="[0-9]{3}-[0-9]{3}-[0-9]{4}"
      inputMode="tel"
      description={{
        value: 'This input is automatically formatted for our uses. Please only input numbers.',
        isHidden: true,
      }}
      {...props}
    />
  );
};
